import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import { getExpendType } from '@store/modules/finance/expend_type';
import { querySaveSeal, querySealWorkflow } from '@api/administrative/seal';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    this.sealWorkflow();
    const { dispatch } = this.props;
    dispatch(getExpendType());
  }

  /**
   * 提交用章
   */
  handSubmit = item => {
    delete item.apportionType;
    this.saveSeal(item);
  };

  sealWorkflow = params => {
    const { instance } = this.state;
    querySealWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveSeal = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveSeal(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  hideModal = () => {};

  render() {
    const { isSubmitting, instance, dataInfo } = this.state;
    return (
      <div>
        <FormBase data={dataInfo} handSubmit={this.handSubmit} isSubmitting={isSubmitting} />
        <Card>
          <Process instance={instance} />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
}))(Page);



// WEBPACK FOOTER //
// ./src/components/administrative/seal/PageAdd.js